module.exports = __webpack_public_path__ + "img/IconGateway.3791b5ae.png";